import { createRoot } from "react-dom/client";
import { ensureIdentity } from "./lib/visitorId";
import App from "./App.tsx";
import "./index.css";

// Mint visitor/session ids synchronously before React (or auth) mounts, so the
// very first tracked event of a session already carries both ids.
ensureIdentity();


createRoot(document.getElementById("root")!).render(<App />);
